import { Icon, IconButton, Table, TableBody, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import FormField from "layouts/pages/users/new-user/components/FormField";

const variablesColumns = [
    { name: "nome" },
]

export function LawyerTable({ rows, removeRow, handleData }) {

    return (
        <MDBox sx={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table stickyHeader>
                <MDBox component="thead" >
                    <TableRow>
                        {variablesColumns?.map((cols, idx) =>
                            <DataTableHeadCell
                                key={idx}
                                width={"auto"}
                                align={cols.align}
                                sorted={false}>
                                {cols.name || "N/A"}
                            </DataTableHeadCell>
                        )}
                        <DataTableHeadCell
                            width={"auto"}
                            align="center"
                            sorted={false}>
                            Remover
                        </DataTableHeadCell>
                    </TableRow>
                </MDBox>
                <TableBody>
                    {rows?.map((row, key) => {
                        return (
                            <TableRow key={key}>
                                <DataTableBodyCell style={{ width: "100%" }}>
                                    <FormField
                                        type="text"
                                        name="nome"
                                        placeholder=""
                                        value={row.nome || ""}
                                        onChange={({ target }) => handleData(key, target.value)}
                                        required
                                    />
                                </DataTableBodyCell>
                                <DataTableBodyCell align="center">
                                    <IconButton
                                        aria-label="delete"
                                        aria-haspopup="true"
                                        onClick={() => removeRow(key)}>
                                        <MDTypography variant="h4" color="error">
                                            <Icon>delete</Icon>
                                        </MDTypography>
                                    </IconButton>
                                </DataTableBodyCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </MDBox>
    );
}